import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_m8c3mbnsfa: FaireBrandEntity = {
  token: "b_m8c3mbnsfa",
  type: "brand",
  name: "Urban Tokyo",
  avatarUrl: "https://cdn.faire.com/fastly/78d626bb46a974d3048fcbb6564085222b2a680dfffee739917f9f6c25586ad2.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/19b41f914f8bf4d46e30f23ea7e9493e36c933983b3325bee105958c43d23fcd.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/78d626bb46a974d3048fcbb6564085222b2a680dfffee739917f9f6c25586ad2.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/19b41f914f8bf4d46e30f23ea7e9493e36c933983b3325bee105958c43d23fcd.jpeg",
  location: "Plano, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 404,
  isTopShop: true,
  isInsider: true,
  description: "At Urban Tokyo, we are dedicated to offering high-quality products that capture the essence of Japanese style and innovation. Each item is carefully selected for its exceptional craftsmanship, functionality, and aesthetic charm, reflecting our commitment to superior quality and design. Our diverse range includes traditional Japanese tableware, kitchenware, home goods, and lifestyle products, adding a touch of elegance and sophistication to your daily life",
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:56:45.232Z",
    importedBy: "entity-db-cli"
  }
};
